import { eventChannel } from "redux-saga"
import { put, take, takeEvery, call, all } from "redux-saga/effects"
import uuid4 from "uuid/v4"
import env from "src/env"
import { selectToken } from "src/engine/modules/session/selectors"
import { getStore } from "src/engine/plugins/BridgeStore"
import {
  CONNECT_WEBSOCKET,
  DISCONNECT_WEBSOCKET,
  WS_NOTIFICATIONS_ADD_MSG,
  WEBSOCKET_CONNECTION_FAILED,
} from "../actions/types"

const { REACT_APP_WS_URL } = env
const NORMAL_SHUTDOWN_REASON = `Shutdown`
let channel = null

const createEventChannel = (socket, token) =>
  eventChannel(emit => {
    const setSocketListeners = socketToHandle => {
      // Connection opened
      socketToHandle.addEventListener(`open`, () => {
        // eslint-disable-next-line no-console
        console.log(`open...`)
      })

      // Reconnect
      socketToHandle.addEventListener(`close`, evt => {
        if (evt.code !== 1000 && evt.reason !== NORMAL_SHUTDOWN_REASON) {
          const newSocket = new WebSocket(
            `${REACT_APP_WS_URL}?token=${token}&sessionId=${uuid4()}}`,
          )
          setSocketListeners(newSocket)
        }
      })

      // Listen for messages
      socketToHandle.addEventListener(`message`, event => {
        const parsedMessage = JSON.parse(event.data)
        emit(parsedMessage)
      })
    }

    setSocketListeners(socket)

    return () => {
      socket.close(1000, NORMAL_SHUTDOWN_REASON)
    }
  })

function* connectToServer() {
  const token = selectToken(getStore().getState())
  const ws = new WebSocket(`${REACT_APP_WS_URL}?token=${token}&sessionId=hello`)
  channel = yield call(createEventChannel, ws, token)
  try {
    while (true) {
      const msg = yield take(channel)
      yield put({ type: WS_NOTIFICATIONS_ADD_MSG, msg })
    }
  } catch (error) {
    yield put({ type: WEBSOCKET_CONNECTION_FAILED, error })
    channel.close()
  }
}

function disconnectFromServer() {
  if (channel) {
    channel.close()
    channel = null
  }
}

function* connectToWebsocketServer() {
  yield takeEvery(CONNECT_WEBSOCKET, connectToServer)
  yield takeEvery(DISCONNECT_WEBSOCKET, disconnectFromServer)
}

export default function*() {
  while (true) {
    yield all({
      connectWebsocket: connectToWebsocketServer(),
    })
  }
}
